import { ca } from '@cian/analytics';

export type TDealType = 'sale' | 'rent';

export function trackResponseSuccess(dealType: TDealType) {
  ca('event', {
    action: 'contract_send',
    category: 'card',
    label: `${dealType}_contract`,
    name: 'oldevent',
  });
}

export function trackShowContract() {
  ca('event', {
    action: 'contract_show',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
